/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { observer } from 'mobx-react';
import { FullGuideDTO } from 'dto/guide';
import { useStores } from 'util/mobx/stores';
import { useTranslation } from 'react-i18next';

import ItemMenu from 'components/ItemMenu';
import ItemMenuButton from 'components/ItemMenuButton';
import Popover from 'components/Popover';

interface Props {
  guide: FullGuideDTO;
  actions?: JSX.Element;
  groupType: string;
}

const ItemActions = observer(({ guide, groupType }: Props) => {
  const { materialSetsStore, searchStore, guideStore } = useStores();
  const { t } = useTranslation(groupType);
  const { t: searchTranslation } = useTranslation('materialSearch');

  const handleSwitchSearchClick = async () => {
    searchStore.openSearchPanel(m => {
      if (materialSetsStore.materialSetDetail) {
        guideStore.replaceMaterialInGuide(m, { materialSetId: materialSetsStore.materialSetId }, guide.guideId).then(() => {
          if (materialSetsStore.materialSetId) {
            materialSetsStore.loadGuides(materialSetsStore.materialSetId);
          }
        });
      }
    }, searchTranslation('searchItem.replace'));
  };

  const handleDeleteGuideMaterialClick = async () => {
    if (materialSetsStore.materialSetId) {
      await guideStore.deleteGuideMaterials({
        guideId: guide.guideId,
        materialSetId: materialSetsStore.materialSetId
      });
      materialSetsStore.loadGuides(materialSetsStore.materialSetId);
    }
  };

  return (
    <Popover trigger={<img src="images/icon_menu_dots.svg" alt="" className="image_dots_post image-dots-post" />}>
      {({ handleClose, isOpen }) => (
        <>
          <ItemMenu isOpen={!!isOpen} handleClose={handleClose}>
            <ItemMenuButton
              label={t('globalFunctions.dropdownMenu.replaceMaterial')}
              icon="icon_find_16.svg"
              isInPopover
              handleClick={handleSwitchSearchClick}
            />
            <ItemMenuButton
              label={t('globalFunctions.dropdownMenu.deleteMaterial')}
              icon="icon_bin_16.svg"
              warning
              isInPopover
              handleClick={handleDeleteGuideMaterialClick}
            />
          </ItemMenu>
        </>
      )}
    </Popover>
  );
});

export default ItemActions;
